import type { SchemaInput } from './schema-input.js';
import { isString } from './runtime-values.js';

export function safeReturnTo(value: SchemaInput): string {
  if (!isString(value)) return '/';
  const trimmed = value.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//') || trimmed.includes('\\')) return '/';
  try {
    return new URL(trimmed, 'https://drawonamap.com').origin === 'https://drawonamap.com' ? trimmed : '/';
  } catch {
    return '/';
  }
}
